<template>
    <div class="h-full">
        <main class="max-w-7xl mx-auto pb-10 lg:py-12 lg:px-8">
            <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
                <!-- SIDENAV -->
                <aside class="py-6 px-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
                    <nav class="space-y-1">
                        <Link v-for="item in nav" :key="item.name" :href="item.href" :class="[
                            route().current(item.current)
                                ? 'bg-gray-50 text-minplan-blue hover:bg-white'
                                : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50',
                            'group rounded-md px-3 py-2 flex items-center text-sm font-medium',
                        ]" :aria-current="item.current ? 'page' : undefined">
                        <component :is="item.icon" :class="[
                            route().current(item.current)
                                ? 'text-minplan-blue'
                                : 'text-gray-400 group-hover:text-gray-500',
                            'flex-shrink-0 -ml-1 mr-3 h-6 w-6',
                        ]" aria-hidden="true" />
                        <span class="truncate">
                            {{ $t(item.name) }}
                        </span>
                        </Link>
                    </nav>
                </aside>

                <!-- CONTENT -->
                <div class="space-y-6 sm:px-6 lg:px-0 lg:col-span-9">
                    <slot></slot>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import {
    ClipboardListIcon,
    ColorSwatchIcon,
    OfficeBuildingIcon,
    ReceiptTaxIcon,
    TruckIcon,
    UsersIcon,
    TrashIcon
} from "@heroicons/vue/outline";

export default defineComponent({
    components: {
        Link,
        OfficeBuildingIcon,
        UsersIcon,
        ColorSwatchIcon,
        TruckIcon,
        ClipboardListIcon,
        TrashIcon
    },
    mounted() {
        const user = this.$page.props.user;
        const isAdmin = this.$page.props.isAdmin;
        const isSuperAdmin = this.$page.props.isSuperAdmin;
        const nav = [
            {
                name: "settings.templates",
                href: this.route("advisors.templates.index"),
                icon: ClipboardListIcon,
                current: "advisors.templates.index"
            },
            {
                name: "settings.suppliers",
                href: this.route("advisors.suppliers.index"),
                icon: TruckIcon,
                current: "advisors.suppliers.index"
            },
            {
                name: "settings.options",
                href: this.route("advisors.option-sets.index"),
                icon: ColorSwatchIcon,
                current: "advisors.option-sets.index"
            }
        ];

        const agencyUUID = user?.currentAgencyUUID;

        if (agencyUUID) {
            nav.push({
                name: "settings.team",
                href: this.route("advisors.agencies.show", agencyUUID),
                icon: UsersIcon,
                current: "advisors.agencies.show"
            });

            if (user.currentAgencyRole === 'owner' || user.currentAgencyRole === 'manager' || isAdmin || isSuperAdmin) {
                nav.push({
                    name: "agencies.branding",
                    href: this.route("advisors.agencies.branding.show", agencyUUID),
                    icon: ColorSwatchIcon,
                    current: "advisors.agencies.branding.show"
                });
            }
        }

        if (isAdmin || isSuperAdmin) {
            const adminNav = [
                {
                    name: "settings.agencies",
                    href: this.route("admin.agencies.index"),
                    icon: OfficeBuildingIcon,
                    current: "admin.agencies.index"
                },
                {
                    name: "settings.taxes",
                    href: this.route("advisors.taxRates.index"),
                    icon: ReceiptTaxIcon,
                    current: "advisors.taxRates.index"
                },
                {
                    name: "admin.globalBranding",
                    href: this.route("admin.branding.index"),
                    icon: ColorSwatchIcon,
                    current: "admin.branding.index"
                }
            ];

            if (isSuperAdmin) {
                adminNav.splice(1, 0, {
                    name: "settings.clearAgencies",
                    href: this.route("admin.agencies.clear"),
                    icon: TrashIcon,
                    current: "admin.agencies.clear"
                });
            }

            nav.push(...adminNav);
        }

        this.nav = nav;
    },
    data() {
        return {
            nav: []
        };
    }
});
</script>
